import { Menu, MenuItem, Snackbar, Button, Alert } from "@mui/material";
import React, { useEffect, useState } from "react";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import UploadIcon from "@mui/icons-material/Upload";
import axios from "axios";
import { api, post } from "../../../utils/api";
import { token } from "../../../utils/companyId";

const MenuActions = ({
  handleView,
  handleEdit,
  handleDelete,
  anchorEl,
  handleMenuClose,
  setBulkUploadModal,
  id,
  partnerType,
  selectedData,
}) => {
  // console.log("idddddddddd",selectedData)

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [request, setRequest] = useState(false);

  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  useEffect(() => {
    if (partnerType === "existing" && selectedData) {
      setRequest(selectedData.sendForApproval);
    }
  }, [partnerType, selectedData]);

  const handleRequestData = async () => {
    try {
      handleMenuClose();
      const response = await post(`${api}/valueChain/request/requestData`, {
        _id: id,
      });

      setsnackOpen({
        open: true,
        message: response?.data?.message,
        severity: "success",
      });
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error?.response?.data?.message,
        severity: "error",
      });
    }
  };

  const handleUploadData = async (e) => {
    handleMenuClose();
    const files = e.target.files;

    if (!files || files.length === 0) {
      setsnackOpen({
        open: true,
        message: "Please select a file.",
        severity: "error",
      });
      return;
    }

    const file = files[0];

    // Validate file type
    const validMimeTypes = [
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    ];

    if (!validMimeTypes.includes(file.type)) {
      setsnackOpen({
        open: true,
        message: "Invalid file type. Please upload an Excel file.",
        severity: "error",
      });
      return;
    }

    const formData = new FormData();
    formData.append("files", file);

    try {
      // Step 1: Upload the file
      const uploadResponse = await axios.post(`${api}/cloud/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // Get the uploaded file's URL
      const uploadedUrl = uploadResponse.data.urls[0];
      console.log("File uploaded successfully:", uploadedUrl);

      // Step 2: Send the PUT request with the uploaded URL
      const putResponse = await axios.put(
        `${api}/valueChain/request/update/?Id=${id}`,
        { uploadExcelUrl: uploadedUrl }
      );

      console.log("PUT request response:", putResponse.data);

      // Show success Snackbar
      setsnackOpen({
        open: true,
        message: "File uploaded successfully.",
        severity: "success",
      });
    } catch (error) {
      console.error("Error in file upload or URL update:", error);
      setsnackOpen({
        open: true,
        message: "Error occurred during file upload or URL update.",
        severity: "error",
      });
    } finally {
    }
  };

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            width: "160px",
            border: "1px solid #ddd",
            marginLeft: "-47px",
          },
        }}
      >
        {/* {partnerType === "existing" && selectedData.action === "Pending" ? (
          <MenuItem onClick={handleRequestData} sx={{ fontSize: "14px" }}>
            <RequestPageIcon sx={{ marginRight: "8px", fontSize: "large" }} />
            Send for Approval
          </MenuItem>
        ) : (
          <MenuItem onClick={handleRequestData} sx={{ fontSize: "14px" }}>
            <RequestPageIcon sx={{ marginRight: "8px", fontSize: "large" }} />
            Re-Request Data
          </MenuItem>
        )} */}

        {partnerType === "existing" && selectedData.action !== "Accepted" && (
          <MenuItem onClick={handleRequestData} sx={{ fontSize: "14px" }}>
            <RequestPageIcon sx={{ marginRight: "8px", fontSize: "large" }} />
            Re-Request Data
          </MenuItem>
        )}

        {partnerType === "new" && (
          <MenuItem sx={{ fontSize: "14px" }}>
            <UploadIcon sx={{ marginRight: "8px", fontSize: "large" }} />
            <input
              type="file"
              accept=".xls,.xlsx"
              onChange={handleUploadData} // Calling the new upload function here
              style={{ display: "none" }}
              id="file-upload"
            />
            <Button
              variant="text"
              color="primary"
              sx={{
                fontSize: "14px",
                textTransform: "none",
                color: "black",
                padding: 0,
              }}
              onClick={() => setBulkUploadModal(true)}
            >
              Upload Data
            </Button>
          </MenuItem>
        )}
      </Menu>

      <Snackbar
        open={snackOpen.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          // onClose={handleClose}
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
          {/* Add user Successfully */}
        </Alert>
      </Snackbar>
    </>
  );
};

export default MenuActions;
